import { Component } from "react";
import { Link } from "react-router-dom";
import {
  IoAdd,
  IoClose,
  IoHelpCircleOutline,
  IoArrowForward,
} from "react-icons/io5";

import "../styles/orange_faq_accordion.css";

class OrangeFaqAccordion extends Component {
  render() {
    // 1. DYNAMIC PROPS WITH FALLBACKS
    const title = this.props.title || (
      <>
        Your Questions, <br /> Answered
      </>
    );
    const subtitle = this.props.subtitle || "FAQ";

    const faqs = this.props.faqs || [
      {
        id: "faq1",
        question: "What are XLP Workshops?",
        answer:
          "XLP Workshops are interactive learning sessions designed to introduce students to future-ready skills such as robotics, design thinking, technology, and innovation through hands-on activities and guided learning experiences.",
      },
      {
        id: "faq2",
        question: "Who can attend XLP Workshops?",
        answer:
          "XLP Workshops are designed primarily for school students, typically from middle school to high school levels. Specific workshops may be tailored to different age groups.",
      },
      {
        id: "faq3",
        question: "Do students need prior technical knowledge to attend?",
        answer:
          "No prior knowledge is required. The workshops are designed for beginners and focus on introducing concepts in a simple and engaging way so that every student can participate and learn.",
      },
      {
        id: "faq4",
        question: "How long does a workshop usually last?",
        answer:
          "Most XLP workshops are conducted as half-day or full-day sessions, depending on the topic and learning activities included.",
      },
      {
        id: "faq5",
        question: "What will students learn from these workshops?",
        answer:
          "Students gain exposure to technology, creative problem-solving, teamwork, and innovation. The workshops focus on building practical understanding and encouraging curiosity.   ",
      },
      {
        id: "faq6",
        question: "Are the workshops practical or theory-based?",
        answer:
          "XLP workshops are highly practical and activity-driven. Students participate in demonstrations, discussions, and hands-on exercises to understand the concepts better.",
      },
    ];

    return (
      <section id="FAQ" className="orange-faq-section py-4">
        <div className="container py-4">
          <div className="row g-5">
            {/* ==========================================
                LEFT COLUMN: TITLE & CONTACT CARD
                ========================================== */}
            <div className="col-12 col-lg-5 pe-lg-5">
              <div>
                <span className="text-white fw-medium mb-3 d-block">
                  {subtitle}
                </span>
                <h2
                  className="display-4 fw-bold text-white mb-5"
                  style={{ letterSpacing: "-1px" }}
                >
                  {title}
                </h2>

                {/* Contact Help Card */}
                <div className="help-card p-4 rounded-4">
                  <IoHelpCircleOutline
                    size={32}
                    color="#ffffff"
                    className="mb-3"
                  />
                  <p
                    className="text-white mb-4"
                    style={{ fontSize: "16px", lineHeight: "1.6" }}
                  >
                    If your question isn't listed here, reach out and we'll
                    help.
                  </p>
                  <Link
                    to="/contact_screen"
                    className="btn btn-outline-light d-inline-flex align-items-center gap-2 border-0 px-0"
                    style={{
                      backgroundColor: "transparent",
                      fontWeight: "500",
                    }}
                  >
                    Contact Us <IoArrowForward />
                  </Link>
                </div>
              </div>
            </div>

            {/* ==========================================
                RIGHT COLUMN: THE ACCORDION
                ========================================== */}
            <div className="col-12 col-lg-7">
              <div className="accordion orange-accordion" id="orangeFaqRoot">
                {faqs.map((faq, index) => (
                  <div className="accordion-item" key={faq.id}>
                    <h2 className="accordion-header" id={`heading-${faq.id}`}>
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${faq.id}`}
                      >
                        <span className="fw-medium text-dark pe-3">
                          {faq.question}
                        </span>

                        <div className="ms-auto flex-shrink-0 ">
                          <IoAdd size={28} className="icon-closed" />
                          <IoClose size={28} className="icon-opened" />
                        </div>
                      </button>
                    </h2>

                    <div
                      id={`collapse-${faq.id}`}
                      className="accordion-collapse collapse"
                      data-bs-parent="#orangeFaqRoot"
                    >
                      <div className="accordion-body text-secondary pt-0 pb-4 pe-lg-5">
                        <p
                          className="mb-0"
                          style={{ lineHeight: "1.6", fontSize: "15px" }}
                        >
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default OrangeFaqAccordion;
